export type ServerEnvironment = 'ssr';
type DesignerEnvironment = 'designer';
export type BrowserEnvironment = DesignerEnvironment;

export type Environment =
  | BrowserEnvironment
  | ServerEnvironment
  | 'export'
  | 'llm';

export const WebflowEnvironments = Object.freeze({
  DESIGNER: 'designer' as DesignerEnvironment,
  SSR: 'ssr' as ServerEnvironment,
  EXPORT: 'export' as const,
  LLM: 'llm' as const,
});
